import { yupResolver } from '@hookform/resolvers/yup';
import { IReplyValuesFormMeta } from '@Modules/admin/integrationSettings/containers/mixedHandlers/atm/replyValues/replyValuesMeta';
import { CustomTextInput } from '@Modules/core/components';
import CustomFormControl from '@Modules/core/components/form/CustomFormControl';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import { TFormUIProps } from '@Modules/core/types/FormUIPropsType';
import displayCustomInputs from '@Shared/utils/displayCustomInputs';
import React from 'react';
import { useForm } from 'react-hook-form';

type Props = {
    meta: IReplyValuesFormMeta
} & TFormUIProps;

const ReplyValuesFormUI: React.FC<Props> = ({ onSubmit, isLoading, meta }) => {
    
    const {
        register,
        handleSubmit,
        formState: { errors }, 
    } = useForm({ resolver: yupResolver(meta.schema) });

    const arrName = [meta.bankID.name, meta.corporateName.name, meta.id.name, meta.replyConfiguration.name];
    
    // const columns = getReplyValuesTableColumns({isLoading, openModal});
    
    return (
        <CC.Box as={'form'} onSubmit={handleSubmit(onSubmit)}>
            <CC.SimpleGrid columns={{base: 1, md: 2}} spacing={10} my={10}>
                
                {displayCustomInputs<IReplyValuesFormMeta>(
                meta,
                register,
                errors,
                isLoading, [...arrName]
                )}

                <CC.HStack>
                    <CC.Box as={"span"}>{meta.pstdxCode.label}</CC.Box>
                    <CustomFormControl w={"20%"} isLoading={isLoading} isInvalid={!!errors[meta.pstdxCode.name]}>
                        <CustomTextInput hasError={errors[meta.pstdxCode.name]} register={register(meta.pstdxCode.name)} meta={meta.pstdxCode}/>
                    </CustomFormControl>
                    <CustomFormControl isLoading={isLoading} isInvalid={!!errors[meta.pstdxDescription.name]}>
                        <CustomTextInput hasError={errors[meta.pstdxDescription.name]} register={register(meta.pstdxDescription.name)} meta={meta.pstdxDescription}/>
                    </CustomFormControl>
                </CC.HStack>

                <CC.HStack>
                    <CC.Box as={"span"}>{meta.serviceCode.label}</CC.Box>
                    <CustomFormControl w={"20%"} isLoading={isLoading} isInvalid={!!errors[meta.serviceCode.name]}>
                        <CustomTextInput hasError={errors[meta.serviceCode.name]} register={register(meta.serviceCode.name)} meta={meta.serviceCode}/>
                    </CustomFormControl>
                    <CustomFormControl isLoading={isLoading} isInvalid={!!errors[meta.serviceDescription.name]}>
                        <CustomTextInput hasError={errors[meta.serviceDescription.name]} register={register(meta.serviceDescription.name)} meta={meta.serviceDescription}/>
                    </CustomFormControl>
                </CC.HStack>
                
            </CC.SimpleGrid>

            {/* <CC.Stack my={10}>
                <CustomReactTable columns={columns} data={ReplyValuesTableFakeData} />
            </CC.Stack>

            <CustomAppModal
                title={`Modification du tableau`}
                actionBtnText="Valider"
                actionBtnClick={replyValuesModalRef.current?.onClose}
                ref={replyValuesModalRef}
                size="4xl"
                isCentered
            >
                <CC.Box
                    as="fieldset"
                    border={'1px solid var(--chakra-colors-gray-300)'}
                    borderRadius={'10px'}
                    my={6}
                    maxW={'100%'}
                    p={6}
                >
                    <CC.Heading as="legend" ml={'15px'} fontSize={'md'}>
                        Condition
                    </CC.Heading>

                    <CC.SimpleGrid columns={{base: 1, md: 2}} spacing={10}>
                        {displayInputs(tableFieldFormName.slice(0, 5))}
                    </CC.SimpleGrid>
                </CC.Box>

                <CC.Box
                    as="fieldset"
                    border={'1px solid var(--chakra-colors-gray-300)'}
                    borderRadius={'10px'}
                    my={6}
                    maxW={'100%'}
                    p={6}
                >
                    <CC.Heading as="legend" ml={'15px'} fontSize={'md'}>
                        Résultat
                    </CC.Heading>

                    <CC.SimpleGrid columns={{base: 1, md: 2}} spacing={10}>
                        {displayInputs(tableFieldFormName.slice(6, tableFieldFormName.length - 1), "select")}

                    </CC.SimpleGrid>

                    <CC.Stack mt={10}>
                        {displayInputs([tableFieldFormName[ tableFieldFormName.length - 1]], "select")}

                    </CC.Stack>

                    <CC.Center alignItems={"center"} my={4}>
                        <CustomFormControl isLoading={isLoading} isInvalid={!!errors[meta.type.name]} w={"auto"}>
                            <CustomInputCheckBox hasError={errors[meta.type.name]} register={register(meta.type.name)} meta={meta.type}>
                                {meta.type.label}
                            </CustomInputCheckBox>

                        </CustomFormControl>
                    </CC.Center>
                </CC.Box>


            </CustomAppModal> */}
        
            {/* <CC.HStack my={6} justifyContent={'flex-end'}>
                <CustomSaveBtn isLoading={isLoading} isSubmitting={isSubmitting} />
            </CC.HStack> */}
        </CC.Box>
    );
};

export default ReplyValuesFormUI;
